import { render, staticRenderFns } from "./header_credit.vue?vue&type=template&id=cfd63eb2&"
import script from "./header_credit.vue?vue&type=script&lang=js&"
export * from "./header_credit.vue?vue&type=script&lang=js&"
import style0 from "./header_credit.vue?vue&type=style&index=0&id=cfd63eb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports